import { Component, inject } from '@angular/core';
import { UserService } from '../../../services/user/user.service';
import { LanguageService } from '../../../services/language.service';
import { SideNavService } from '../../layout/side-menu/side-nav.service';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { BtnComponent } from '../btn/btn.component';
import { TextGradientComponent } from '../text-gradient/text-gradient.component';
import { NgClass, LowerCasePipe, AsyncPipe } from '@angular/common';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { GamesLauncherService } from '../../../services/games/games-launcher.service';

@Component({
  selector: 'app-header-balance',
  templateUrl: './header-balance.component.html',
  styleUrls: ['./header-balance.component.scss'],
  imports: [
    RouterLink,
    RouterLinkDirective,
    TextGradientComponent,
    BtnComponent,
    NgClass,
    LowerCasePipe,
    CurrencyFormatPipe,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class HeaderBalanceComponent {
  user = inject(UserService);
  lang = inject(LanguageService);
  sidebar = inject(SideNavService);
  launcher = inject(GamesLauncherService);

}
